import React, { useEffect, useRef, useState, useMemo } from 'react';
import { BarLoader } from 'react-spinners';
import { motion, AnimatePresence, useAnimation } from "framer-motion";

import styled from 'styled-components';

import PopoverHover from 'SharedComponents/popover-hover';

import log from "Utils/logger";

import styles from './index.css';


const FeatureIconsWrapper = styled.div`${styles}`;

  const FeatureIcons = ({ selectedSubscriptionPlan }) => {

    const [currentFeatures, setCurrentFeatures] = useState({});
    const prevFeaturesSnapshotRef = useRef({});
    const holdFeaturesForSnapshotRef = useRef({});

    useEffect(() => {
      console.log("🆕 ** **  FeatureIcons mounted");
      return () => console.log("❌ ** ** FeatureIcons unmounted");
    }, []);
    

    console.log("** ** FeatureIcons triggered with selectedSubscriptionPlan: ", selectedSubscriptionPlan);
    console.log("** ** FeatureIcons triggered with currentFeatures: ", currentFeatures);
    console.log("** ** FeatureIcons triggered with prevFeaturesSnapshotRef.current: ", prevFeaturesSnapshotRef.current);
    console.log("** ** FeatureIcons triggered with holdFeaturesForSnapshotRef.current: ", holdFeaturesForSnapshotRef.current);

    useEffect(() => {
      
      console.log("** ** FeatureIcons useEffect triggered with state selectedSubscriptionPlan: ", selectedSubscriptionPlan);
      if (!selectedSubscriptionPlan?.subscriptionPlanFeatures) return;

      const updatedFeatures = {};
      selectedSubscriptionPlan.subscriptionPlanFeatures.forEach((feature) => {
        updatedFeatures[feature.name] = feature.available;
      });
    
      console.log("** ** FeatureIcons useEffect about to set currentFeatures to updatedFeatures : ", updatedFeatures);
      console.log("** ** FeatureIcons useEffect about to set prevFeaturesSnapshot to holdFeaturesForSnapshotRef.current : ", holdFeaturesForSnapshotRef.current);
      console.log("** ** FeatureIcons useEffect about to set holdFeaturesForSnapshotRef.current to updatedFeatures : ", updatedFeatures); 
      // Snapshot the previous features before updating
      //setPrevFeaturesSnapshot(holdFeaturesForSnapshotRef.current);
      if (holdFeaturesForSnapshotRef.current) {
        prevFeaturesSnapshotRef.current = holdFeaturesForSnapshotRef.current;
      }
      
      holdFeaturesForSnapshotRef.current = updatedFeatures;
      setCurrentFeatures(updatedFeatures);

    },[selectedSubscriptionPlan]);


    if (!selectedSubscriptionPlan?.subscriptionPlanFeatures) {
      console.log("FeatureIcons: No selectedSubscriptionPlan yet, skipping render.");
      return null;
    }

    return (
      <FeatureIconsWrapper>
        <div className="features-container">
          
            {selectedSubscriptionPlan.subscriptionPlanFeatures.map((feature, index) => {
              const featureKey = feature.name;
              const prevState = prevFeaturesSnapshotRef.current[featureKey];
              const newState = feature.available;
              const hasChanged = prevState !== newState;

              //console.log(`selectedSubscriptionPlan FeatureIcons index ${index} triggered dex:`);
              console.log(`** ** FeatureIcons index ${index} triggered with featureKey: ' ${featureKey}`);
              console.log(`** ** FeatureIcons index ${index} triggered with prevFeaturesSnapshotRef.current: ${JSON.stringify(prevFeaturesSnapshotRef.current, null, 2)}`);
              console.log(`** ** FeatureIcons index ${index} triggered with feature: ${JSON.stringify(feature, null, 2)}`);
              console.log(`** ** FeatureIcons index ${index} triggered with state prevState: ${prevState}`);
              console.log(`** ** FeatureIcons index ${index} triggered with state newState: ${newState}`);
              console.log(`** ** FeatureIcons index ${index} triggered with state hasChanged: ${hasChanged}`);

              

              return (
                <div className="feature" key={featureKey} layout>
                  <AnimatePresence mode="wait" initial={false}>
                  { hasChanged ? (
                    
                      <motion.i
                        key={`${featureKey}-${newState}-animated`} // Only used in animate mode
                        className="material-icons"
                        initial={{
                          scale: 1, 
                          opacity: 1, 
                          color: prevState ? "#000" : "#c7c7c7",
                        }}
                        animate={{
                          scale: 1.1,
                          opacity: 1,
                          color: newState ? "#000" : "#c7c7c7",
                        }}
                        exit={{
                          scale: 1,
                          opacity: 1,
                          transition: { duration: 0.3, delay: index * 0.3 },
                          color: prevState ? "#000" : "#c7c7c7",
                        }}
                        transition={{
                          duration: 0.4,
                          delay: index * 0.2,
                        }}
                      >
                        check_circle
                      </motion.i>
                    
                  ) : (
                    <motion.i
                    key={`${featureKey}-${newState}-static`} // Triggers re-animation
                    className={`material-icons ${newState ? "available" : "not-available"}`}
                    initial={{ opacity: 1, scale: 1 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0 }} 
                  >
                    check_circle
                  </motion.i>

                )}
                </AnimatePresence>

                  <span className="feature-text">
                    {feature.label || featureKey}
                    {feature.description && (
                      <span className="pop-over-container">
                        <PopoverHover
                          content={
                            <div
                              style={{
                                maxWidth: "300px",
                                padding: 10,
                                fontSize: "16px",
                                fontWeight: "bold",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "left",
                              }}
                            >
                              {feature.description}
                            </div>
                          }
                          header={null}
                          img={null}
                          itemToPopover={
                            <i
                              className="material-icons"
                              style={{
                                margin: "0 5px",
                                fontSize: "16px",
                                color: "#495c63",
                              }}
                            >
                              info
                            </i>
                          }
                          anchorOrigin={{
                            vertical: "center",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "center",
                            horizontal: "right",
                          }}
                        />
                      </span>
                    )}
                  </span>
                </div>
              );
            })}
          
        </div>
      </FeatureIconsWrapper>
    );
  };

export default FeatureIcons;




